<template>
    <div id="profile-page">
        <!-- PROFILE HEADER -->

        <div class="profile-header">
            <div class="relative">
                <div class="cover-container rounded-t-lg">
                    <img :src="user_info.cover_img" alt="user-profile-cover" class="responsive block" />
                </div>
            </div>
        </div>

        <!-- COL AREA -->
        <div class="vx-row m-2">
            <div class="vx-col w-full ">
                <vx-card title="🍱 세부 식사관리">
                    <h5 class="rounded-lg m-3" @input="mealData()">
                        <template v-if="selected.MEDICAL_ROOM_NM != undefined"
                            >👤<b>{{ selected.PATIENT_USERNAME }}</b
                            >({{ selected.MEDICAL_ROOM_NM }} - {{ selected.MEDICAL_ROOM_NUMBER_NM }})</template
                        >
                    </h5>
                    <input type="hidden" v-model="today" />
                    <input type="hidden" v-model="tomorrow" />
                    <input type="hidden" v-model="tomorrow_next" />

                    <vs-table :data="lists" :noDataText="'데이터가 존재하지 않습니다.'">
                        <template slot="thead" search :data="lists">
                            <vs-th class="table_header">날짜</vs-th>
                            <vs-th class="table_header">아침</vs-th>
                            <vs-th class="table_header">점심</vs-th>
                            <vs-th class="table_header">저녁</vs-th>
                        </template>
                        <template>
                            <vs-tr>
                                <vs-td>{{ new Date() | moment('YYYY-MM-DD (ddd)') }} </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select11">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo11" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select12">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo12" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select13">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo13" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                            </vs-tr>
                            <vs-tr>
                                <vs-td>{{
                                    $moment(new Date())
                                        .add(1, 'days')
                                        .format('YYYY-MM-DD (ddd)')
                                }}</vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select21">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo21" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select22">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo22" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select23">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo23" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                            </vs-tr>
                            <vs-tr>
                                <vs-td>{{
                                    $moment(new Date())
                                        .add(2, 'days')
                                        .format('YYYY-MM-DD (ddd)')
                                }}</vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select31">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo31" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select32">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo32" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="demo-alignment">
                                        <vs-select autocomplete class="selectExample" v-model="select33">
                                            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options" />
                                        </vs-select>
                                    </div>
                                    <div class="demo-alignment">
                                        <vs-textarea label="메모내용 입력" v-model="memo33" class="w-full mb-4  mt-5" size="large" />
                                    </div>
                                </vs-td>
                            </vs-tr>
                            <vs-tr>
                                <vs-td colspan="4">
                                    <vs-button class="shadow-md w-full lg:mt-0 mt-4" @click="mealSave">저장</vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import XLSX from 'xlsx';
export default {
    components: {},
    data() {
        return {
            username: '',
            usernameCheck: false,
            userCheckMsg: '',
            selected: [],
            search_username: '',
            lists: [],
            patient_name: '',
            mor_meal: '',
            lunch_meal: '',
            dinner_meal: '',
            select11: '',
            select12: '',
            select13: '',
            select21: '',
            select22: '',
            select23: '',
            select31: '',
            select32: '',
            select33: '',
            memo11: '',
            memo12: '',
            memo13: '',
            memo21: '',
            memo22: '',
            memo23: '',
            memo31: '',
            memo32: '',
            memo33: '',
            options: [
                { text: '일반식', value: 1 },
                { text: '죽', value: 2 },
                { text: '취소', value: 9 },
            ],
            today: this.$moment(new Date()).format('YYYY-MM-DD'),
            tomorrow: this.$moment(new Date())
                .add(1, 'days')
                .format('YYYY-MM-DD'),
            tomorrow_next: this.$moment(new Date())
                .add(2, 'days')
                .format('YYYY-MM-DD'),
            user_info: {
                cover_img: require('@/assets/images/profile/user-uploads/food.png'),
            },
            excelData: [],
            fileName: '',
            sheetName: 'data',
        };
    },
    methods: {
        /** 식사관리 - 환자검색 */

        async mealData() {
            let params = {
                patient_uid: this.uid,
                today: this.today,
                tomorrow: this.tomorrow,
                tomorrow_next: this.tomorrow_next,
            };
            console.log(params);
            const { data } = await axiosClass.get('/api/patient/patientMealInfo', params, true);
            // console.log(data.data[0].CODE_MEAL_1);
            this.select11 = data.data[0].CODE_MEAL_1;
            this.select12 = data.data[0].CODE_MEAL_2;
            this.select13 = data.data[0].CODE_MEAL_3;
            this.select21 = data.data[1].CODE_MEAL_1;
            this.select22 = data.data[1].CODE_MEAL_2;
            this.select23 = data.data[1].CODE_MEAL_3;
            this.select31 = data.data[2].CODE_MEAL_1;
            this.select32 = data.data[2].CODE_MEAL_2;
            this.select33 = data.data[2].CODE_MEAL_3;
            this.memo11 = data.data[0].MEMO_1;
            this.memo12 = data.data[0].MEMO_2;
            this.memo13 = data.data[0].MEMO_3;
            this.memo21 = data.data[1].MEMO_1;
            this.memo22 = data.data[1].MEMO_2;
            this.memo23 = data.data[1].MEMO_3;
            this.memo31 = data.data[2].MEMO_1;
            this.memo32 = data.data[2].MEMO_2;
            this.memo33 = data.data[2].MEMO_3;
        },
        async mealSave() {
            let params = {
                patient_uid: this.uid,
                today: this.today,
                tomorrow: this.tomorrow,
                tomorrow_next: this.tomorrow_next,
                select11: this.select11,
                select12: this.select12,
                select13: this.select13,
                select21: this.select21,
                select22: this.select22,
                select23: this.select23,
                select31: this.select31,
                select32: this.select32,
                select33: this.select33,
                memo11: this.memo11,
                memo12: this.memo12,
                memo13: this.memo13,
                memo21: this.memo21,
                memo22: this.memo22,
                memo23: this.memo23,
                memo31: this.memo31,
                memo32: this.memo32,
                memo33: this.memo33,
                memo11: this.memo11,
                memo12: this.memo12,
                memo13: this.memo13,
                memo21: this.memo21,
                memo22: this.memo22,
                memo23: this.memo23,
                memo31: this.memo31,
                memo32: this.memo32,
                memo33: this.memo33,
                memo11: this.memo11,
                memo12: this.memo12,
                memo13: this.memo13,
                memo21: this.memo21,
                memo22: this.memo22,
                memo23: this.memo23,
                memo31: this.memo31,
                memo32: this.memo32,
                memo33: this.memo33,
            };

            console.log(params);

            const { data } = await axiosClass.post('/api/patient/patientMealSave', params, true);
            console.log(data);
            this.$vs.notify({
                title: `식단저장`,
                text: `식사관리가 저장되었습니다.`,
            });
            //   this.mealData();
            location.href = '/meal/main';
            return;
        },
    },
    created() {
        this.mealData();
    },
    mounted() {
        this.uid = this.$route.params.uid;
    },
};
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/pages/profile.scss';
</style>
